import { render, staticRenderFns } from "./DeleteOneChildMultiGroupDialog.vue?vue&type=template&id=b6830518&scoped=true"
import script from "./DeleteOneChildMultiGroupDialog.vue?vue&type=script&lang=js"
export * from "./DeleteOneChildMultiGroupDialog.vue?vue&type=script&lang=js"
import style0 from "./DeleteOneChildMultiGroupDialog.vue?vue&type=style&index=0&id=b6830518&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b6830518",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/gitlab-runner/builds/VsAMsifqL/0/hero/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b6830518')) {
      api.createRecord('b6830518', component.options)
    } else {
      api.reload('b6830518', component.options)
    }
    module.hot.accept("./DeleteOneChildMultiGroupDialog.vue?vue&type=template&id=b6830518&scoped=true", function () {
      api.rerender('b6830518', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/student/StudentGroupDialog/DeleteOneChildMultiGroupDialog.vue"
export default component.exports